<template>
  <section style="padding: 0.5rem;" class="px-5">
    <div class="container is-max-desktop">
      <div class="columns is-multiline mb-2">

        <div class="column is-full">
          <nav>
            <ul class="breadcrumb" aria-label="Breadcrumb">
              <li>
                <a href="#" title="Página de inicio">
                  Inicio
                </a>
              </li>
              <li>
                <a href="/red-de-atencion" title="Red de atención">Red de
                  atención</a>
              </li>
              <li>
                <span>Módulos express</span>
              </li>
            </ul>
          </nav>
        </div>

      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SucursalBreadcrumb'
}
</script>